















import Vue from 'vue'
import Component from 'vue-class-component'
import VueMultiselect from 'vue-multiselect'
import { Injector } from '@/config/dependency-injection'
import { SharedModule } from '@/shared/store/shared-module'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import { Prop, Watch } from 'vue-property-decorator'
import { AuthenticationService } from '@/authentication/authentication-service'
import { Focusable } from '@/shared/interfaces/focusable'

@Component({
  components: { VueMultiselect },
  data() {
    return {
      internalValue: undefined,
    }
  },
})
export default class RespondecoOrganisationSelect extends Vue implements Focusable {
  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly excludeSelf!: boolean

  @Prop({
    default: () => [],
    type: Array,
  })
  public readonly partners!: OrganisationLite[]

  @Prop({
    default: null,
    type: String,
  })
  public readonly project!: string | null

  @Prop({
    type: Object,
  })
  public readonly value!: OrganisationLite

  public internalValue!: OrganisationLite
  private authenticationService = Injector.get(AuthenticationService)
  private sharedModule = Injector.get(SharedModule)

  public get organisations() {
    let organisations = this.sharedModule.data.organisations

    if (this.excludeSelf === true) {
      const self = this.authenticationService.authenticatedUser()

      organisations = organisations.filter(organisation => organisation.id !== self.organisation.id)
    }

    if (this.partners.length > 0) {
      organisations = organisations.filter(
        organisation => this.partners.some(partner => partner.id === organisation.id) === false
      )
    }

    return organisations
  }

  public focus() {
    const select = (this.$refs.select as unknown) as any

    select.activate()
  }

  public mounted() {
    this.sharedModule.fetchSharedOrganisations({
      project: this.project,
    })
  }

  /**
   * Emit new value
   */
  public updateValue(value: OrganisationLite) {
    this.$emit('input', value)
  }

  /**
   * Prop value changed
   * @param newValue
   */
  @Watch('value')
  public onValueChanged(newValue: OrganisationLite): void {
    this.internalValue = newValue
  }
}
